import { createApi } from "redux-future-middleware";
import { requestApi } from "core/api";
import * as types from "./types";
import * as endpoints from "./endpoints";

export const signIn = createApi({
  name: types.SIGN_IN,
  request: endpoints.signIn
});

export const linkedInSignIn = createApi({
  name: types.LINKEDIN_SIGN_IN,
  request: ({ body }) =>
    requestApi({
      path: "/profile/users/auth/linkedin-oauth2/",
      method: "POST",
      body
    })
});

export const signUp = createApi({
  name: types.SIGN_UP,
  request: endpoints.signUp
});

export const insiderSignUp = createApi({
  name: types.INSIDER_SIGN_UP,
  request: ({ body }) =>
    requestApi({
      path: "/profile/insiders/",
      method: "POST",
      body
    })
});

export const resetPassword = createApi({
  name: types.RESET_PASSWORD,
  request: ({ body }) =>
    requestApi({
      path: "/password-reset/",
      method: "POST",
      body
    })
});

export const setPassword = createApi({
  name: types.SET_PASSWORD,
  request: ({ body }) =>
    requestApi({
      path: "/password-reset/confirm/",
      method: "POST",
      body
    })
});

export const fetchUserData = createApi({
  name: types.FETCH_USER_DATA,
  request: () =>
    requestApi({
      path: "/profile/users/current/",
      method: "GET"
    })
});

export const getDiscountInfo = createApi({
  name: types.GET_DISCOUNT_INFOS,
  request: ({ code }) =>
    requestApi({
      path: `/insiders/check-current-discount-offer/?code=${code}`,
      method: "GET"
    })
});

export const checkUserDiscount = createApi({
  name: types.CHECK_USER_DISCOUNT,
  request: () =>
    requestApi({
      path: `/insiders/check-user-discount/`,
      method: "GET"
    })
});



// WEBPACK FOOTER //
// ./src/modules/user/auth/api.js